import { css } from '@emotion/css';
import { theme } from 'Shared/frontend/SettingsProvider';
import { useVenue } from 'Shared/VenueProvider';
import { Match, Switch } from 'solid-js';
import { ContentKey, contentOptions } from 'Shared/model/Fields';
import { displayState } from 'Shared/frontend/displayState';
import { TextLayout } from 'Shared/model/Components';


export function TextWidget(P:TextLayout & {styling})
{
	const style = () => css(theme().text[P.type], P.styling.css ?? {});
	const htmlStyle = () => css(theme().text[P.type], theme().embeddedHtml, P.styling.css ?? {});

	return (
		<Switch>
			<Match when={P.type == 'teaser'}>
				<div class={`text-teaser ${style()}`} innerHTML={content(P.text)}/>
			</Match>
			<Match when={P.type == 'title'}>
				<h2 class={`text-title ${style()}`} innerHTML={content(P.text)}/>
			</Match>
			<Match when={P.type == 'tagline'}>
				<div class={`text-tagline ${style()}`} innerHTML={content(P.text)}/>
			</Match>
			<Match when={P.type == 'subtitle'}>
				<h3 class={`text-subtitle ${style()}`} innerHTML={content(P.text)}/>
			</Match>
			<Match when={P.type == 'plain' }>
				<div class={`text-plain ${htmlStyle()}`} innerHTML={content(P.text)}/>
			</Match>
			<Match when={true}>
				<div class={style()} innerHTML={content(P.text)}/>
			</Match>
		</Switch>
	);
}

function content(text:string)
{
	return (text ?? '').replace(/{(.*?)}/g, (match, key) => {
		if (! contentOptions[key])
			return match;

		return lookup(key);
	});
}

function lookup(field:ContentKey)
{
	const venue = useVenue();

	switch(field) {
		case 'venue.name':		return venue.name;
		case 'venue.nickname':	return venue.nickname;
		case 'venue.telephone':	return venue.phoneNumber;

		case 'venue.streetAddress':	return venue.streetAddress;
		case 'venue.suburb':		return venue.suburb;
		case 'venue.state':			return displayState(venue.state!);
		case 'venue.country':		return venue.country;
		case 'venue.postcode':		return venue.postcode;

//XXX Q: should I keep these, or require Content component to be used. cf 'firstEmail', 'singleEmail', etc is another option.
		case 'venue.emails':	return emails();
		case 'venue.socials':	return socials();

		case 'lb':				return '{';
		case 'rb':				return '}';
	}
}

/*
	I'm currently making the assumption that text is or may be inline. It's not valid to 
	use <divs> inside  <h1>...<h6>, <p>. If I want to I can use <span>s.
*/

/*
	This is a stripped down version of the emails. Will work OK when there's 
	just a single email, and sometimes when the email addresses contain their functions.
	Otherwise there is a "Content" component version that contains all the information. 
*/
function emails()
{
//XXX cf a table and a row-based versions... Nice if the style could tell us which format needs to be supplied.
	const venue = useVenue();

	let ret = '';
	for (const email of venue.email) 
		if (!email.hide)
			ret += `${email.email} `;

	return ret;
}

/*
	This is a text-only version of social links. Note that the "Content" component has
	a version that uses Icons.
*/
function socials()
{
//TODO it would probably be better to add these items using a repeater in the backend.
//     That way we could allow the user to order them here.

	const venue = useVenue();

	let ret = '';

	if (venue.facebook)
		ret += `<a href="https://www.facebook.com/${venue.facebook}" target="_blank">Facebook</a> `;

	if (venue.instagram)
		ret += `<a href="https://www.instagram.com/${venue.instagram}" target="_blank">Instagram</a> `;

	if (venue.twitter)
		ret += `<a href="https://www.twitter.com/${venue.twitter}" target='_blank'>Twitter</a> `;

	if (venue.tiktok)
		ret += `<a href="https://www.tiktok.com/${venue.tiktok}" target="_blank">TikTok</a> `;

	if (venue.snapchat)
		ret += `<a href="https://www.snapchat.com/add/${venue.snapchat.replace('@','')}" target="_blank">Snapchat</a> `;

	for (const other of venue.otherSocialMedia) 
		ret += `<a href=${other?.url} target="_blank">${other.title}</a> `;

	return ret;
}

